// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDXUYXbGCEnu9deJ2ikYbq3E1ohZOb-dug",
  authDomain: "coin-forecaster-3ccdf.firebaseapp.com",
  projectId: "coin-forecaster-3ccdf",
  storageBucket: "coin-forecaster-3ccdf.appspot.com",
  messagingSenderId: "343061724783",
  appId: "1:343061724783:web:da63cfa2daa8643bf5179a",
  measurementId: "G-VJMVXFRHGZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);